import React from 'react';
import { Button as MuiButton, Box as MuiBox } from '@mui/material';
import styled from 'styled-components';
import type { QuestionInputProps } from '../types/questionnaire';

/**
 * Shared NPS input component for questionnaires
 * Handles: question_nps (Net Promoter Score 1-10)
 */
export const NPSInput: React.FC<QuestionInputProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <SMuiBox>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
        <SButton
          key={i}
          variant="contained"
          color="primary"
          isChecked={value === i}
          onClick={!disabled ? () => onChange(i) : undefined}
          disabled={disabled}
        >
          {i}
        </SButton>
      ))}
    </SMuiBox>
  );
};

const SMuiBox = styled(MuiBox)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }
`;

const SButton = styled(MuiButton)<{
  isChecked?: boolean;
  color: 'primary' | 'secondary';
}>`
  && {
    background-color: ${(props) =>
      props.isChecked
        ? props.theme.palette.colors.blue200
        : props.theme.palette.common.white};
    color: ${(props) =>
      props.isChecked
        ? props.theme.palette[props.color || 'primary'].main
        : props.theme.palette.common.black};
    border: ${(props) =>
      `1px solid ${
        props.isChecked
          ? props.theme.palette[props.color || 'primary'].main
          : props.theme.palette['grey'][100]
      }`};
    border-radius: 5px;
    min-width: 40px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    box-shadow: none;

    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.palette.colors.blue200};
      color: ${(props) => props.theme.palette[props.color || 'primary'].main};
      border: 1px solid
        ${(props) => props.theme.palette[props.color || 'primary'].main};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
